import React, { FC } from 'react';
import { ResponsibleFieldProps } from './ResponsibleFieldProps';
import ResponsibleAutocomplete from './ResponsibleAutocomplete';

const ResponsibleField: FC<ResponsibleFieldProps> = ({
  field,
  label,
  usersList,
  required = false,
}) => {
  return (
    <ResponsibleAutocomplete
      label={label}
      options={usersList || []}
      name={field}
      required={required}
      id={field + '-id'}
      testid={`responsible-field-${label
        .split('' + ' ')
        .join('-')
        .toLowerCase()}`}
    />
  );
};

export default ResponsibleField;
